export default __webpack_public_path__ + "static/media/pokemon_secret_rare.4b326205.svg";